import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FC, PropsWithChildren, StrictMode, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ChatMessagesHandler } from './ChatMessagesHandler';
import { EjectionHandler } from './EjectionHandler';
import { GamificationNotifications } from './GamificationNotifications';
import { GlobalModalsLayer } from './GlobalModalsLayer';
import { MessageHandler } from './MessageHandler';
import { NotificationHandler } from './NotificationHandler';
import { OnlineUsersHandler } from './OnlineUsersHandler';
import { PostHogProvider } from './PostHogProvider';
import { SectionReviewHandler } from './SectionReviewHandler';
import { SocketProvider } from './SocketProvider';
import { UserPingHandler } from './UserPingHandler';
import { UserUpdateHandler } from './UserUpdateHandler';

import { LoadingBar } from '@/components/Loaders';
import { GlobalStyle, BaseThemeProvider, ThemeSync } from '@/styles';

const queryClient = new QueryClient();

export const Providers: FC<PropsWithChildren> = ({ children }) => {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <PostHogProvider>
            <BaseThemeProvider>
              <SocketProvider>
                <Suspense fallback={<LoadingBar />}>{children}</Suspense>
                <EjectionHandler />
                <MessageHandler />
                <NotificationHandler />
                <OnlineUsersHandler />
                <GamificationNotifications />
                <SectionReviewHandler />
                <UserUpdateHandler />
                <UserPingHandler />
                <ChatMessagesHandler />
                <ThemeSync />
                <GlobalStyle />
                <ReactQueryDevtools initialIsOpen={false} />
                <GlobalModalsLayer />
              </SocketProvider>
            </BaseThemeProvider>
          </PostHogProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>
  );
};
